//Base imports and dependancies
import React from 'react'; //react library
import './style.css'; //css style sheet
import { StartApp } from './StartApp.js'; //main app running component
import Button from '@material-ui/core/Button' // styled button from material UI
import StereoDialog from './StereoDialog';  //stereograph dialog for demo


//Import display images
import img from './utils/Images/img.jpg'; // full stereograph scan image
import left from './utils/Images/Left.jpg'; // left crop of stereograph demo
import right from './utils/Images/Right.jpg'; // right crop of stereograph demo
import StereoViews from './utils/Images/stereo views.png'; // demo of parralax images

// Creates app class that displays page and related apps (exports to index.js)
export class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {  image: null,
                    image2:null,
                    status: false,
                  };
  }
  
  changeStatus = () => {
    if (this.state.status === true){
      this.setState({ status: false,
                      image: null,
                      image2: null,
      })
    }
    else if(this.state.status === false) {
      this.setState({ status: true,
                      image: left,
                      image2: right,
      })
    }
    else{console.log('error')}
    console.log(this.state.status, this.state.image, this.state.image2);
  } 
  render(){
  return (
    <div className="App">
      <header style = {{zIndex:'100'}}>
        <link href="style.css" type="text/css" rel="stylesheet"></link>
        <h1 className="mainHead"><strong>University of Wyoming Stereograph</strong></h1>
        <h3 className="welcome"><strong>Welcome</strong> to The University of Wyoming Stereographic Image Creator</h3>
      </header>

      <body>
        <div className = "blurb">
            <div className ='About'>
                <h2 className = 'centerText' >About the App</h2>
                <p>This app is a development project hosted by the University of Wyoming and Funded by a State of Wyoming grant to allow users to animate a collection of scanned stereographic images. The project was in operation for two years and required <strong>blank</strong> hours to complete. The app was completed by a University of Wyoming student (Brayton M. Tolman) finishing his degree in the department of mechanical engineering. Brayton utilized React JavaScript, HTML, CSS, and external react libraries to create this app. </p>
            </div>
            <div className='Wiggle' >
                <h2 className = 'centerText'>What is "Wiggle Stereoscopy"?</h2>
                <p>Wiggle Stereoscopy is an example of stereoscopy in which left and right images of a stereogram are alternated back and forth giving a 3D effect. This technique is also called wiggle 3-D or wobble 3-D. When Images are animated and overlayed the user sees a 3D image effect due to parallax. Parallax is essentially the difference of an object viewed from 2 different lines of sight that create a feeling of depth when processed by the brain.</p>
                <div id="textIMG">
                  <img src={StereoViews} alt="a parralax image" className="initDisplay"/>
                </div>
                <h4 className = 'centerText' style ={{paddingBottom:'10px', paddingTop: '1px'}}><strong>Figure: Parralax between two cameras</strong></h4>
                <p>This parallax effect in conjunction with the animated "wiggle" created by alternating the two viewscreates is a common method of displaying stereographic image data on a 2D screen.</p>
            </div>
            <div className ='Demo'>
                <h2 className = 'centerText'>A Final Product Demo</h2>
                <p>Below is an application demo showing you what the final "wiggle stereoscopy" image for this stereograph as created by the app. <strong>Click the button at the bottom of the image to see it's wiggle animation.</strong> </p>
                <img src={img} className="initDisplay" />
                <Button className='demoButton' id='demoButton' onClick ={this.changeStatus} ><strong>Click for a Stereographic Preview</strong></Button>
                <StereoDialog img={this.state.image} img2={this.state.image2} onClose={this.changeStatus} />
            </div>
        </div>
        <div className="instruct">
            <div id='appBox'>
                  <StartApp />
            </div>
        </div>
      </body>

  
    </div>
  );
  }
}
